import LeyendaEstado from "@/components/pipeline/LeyendaEstado";

export default function DashboardFooter() {
  return (
    <footer
      data-testid="dashboard-footer"
      className="mt-8 border-t border-slate-200 bg-slate-50 rounded-b-2xl px-6 py-4"
    >
      <p className="text-xs text-slate-500">
        Fuente de datos: 32+ fuentes integradas: TrakCare, SAP, LIS, PRM, Athena, AGFA,
        Modulab, RKD, Salesforce, Motor Comunicaciones, entre otras
      </p>
      <div className="flex flex-wrap items-center gap-4 mt-2">
        <LeyendaEstado estado="REAL" />
        <LeyendaEstado estado="MOCK" />
        <LeyendaEstado estado="SIMULADO" />
        <LeyendaEstado estado="PENDIENTE" />
      </div>
    </footer>
  );
}
